var map = {
	"./10_club.jpg": 2617,
	"./10_diamond.jpg": 181,
	"./10_heart.jpg": 2761,
	"./10_spade.jpg": 6782,
	"./2_club.jpg": 9094,
	"./2_diamond.jpg": 8444,
	"./2_heart.jpg": 6404,
	"./2_spade.jpg": 2107,
	"./3_club.jpg": 2289,
	"./3_diamond.jpg": 3277,
	"./3_heart.jpg": 4289,
	"./3_spade.jpg": 9766,
	"./4_club.jpg": 7116,
	"./4_diamond.jpg": 2398,
	"./4_heart.jpg": 6018,
	"./4_spade.jpg": 2033,
	"./5_club.jpg": 3295,
	"./5_diamond.jpg": 4615,
	"./5_heart.jpg": 8719,
	"./5_spade.jpg": 9172,
	"./6_club.jpg": 4738,
	"./6_diamond.jpg": 5960,
	"./6_heart.jpg": 2296,
	"./6_spade.jpg": 9436,
	"./7_club.jpg": 5821,
	"./7_diamond.jpg": 4166,
	"./7_heart.jpg": 7173,
	"./7_spade.jpg": 2810,
	"./8_club.jpg": 7528,
	"./8_diamond.jpg": 7754,
	"./8_heart.jpg": 4022,
	"./8_spade.jpg": 1701,
	"./9_club.jpg": 8475,
	"./9_diamond.jpg": 419,
	"./9_heart.jpg": 2707,
	"./9_spade.jpg": 9816,
	"./a_club.jpg": 707,
	"./a_diamond.jpg": 7643,
	"./a_heart.jpg": 6747,
	"./a_spade.jpg": 2256,
	"./j_club.jpg": 6990,
	"./j_diamond.jpg": 3796,
	"./j_heart.jpg": 764,
	"./j_spade.jpg": 1347,
	"./k_club.jpg": 7577,
	"./k_diamond.jpg": 6677,
	"./k_heart.jpg": 8473,
	"./k_spade.jpg": 1246,
	"./q_club.jpg": 2035,
	"./q_diamond.jpg": 3211,
	"./q_heart.jpg": 3467,
	"./q_spade.jpg": 4320
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6608;